module.exports = __webpack_public_path__ + "fiat.f8ff1fec8e06a65a5caa.png";